<div class="main-busy-bee-container" [class]="themeService.getTheme()" *ngIf="cards.length > 0">
  <div class="title-container mb-4">
    <app-texts *ngIf="!anotherTitle"
      [texts]="textsArray"/>
    <div class="arrows-container">
      <app-arrow [right]="false" (emitClick)="clickLeftButton()" *ngIf="!isLeft"/>
      <app-arrow [right]="true" (emitClick)="clickRightButton()" *ngIf="!isRight"/>
    </div>
  </div>
  <div class="offer-busy-bee-container">
    <app-horizontal-slider #horizontalSlider
      [grid]="grid"
      [hotel]="false"
      [cards]="cards"
      [soloSlide]="soloSlide"
      (positionChanged)="checkPosition($event)"
    />
  </div>
</div>
